import axiosClient from "./axios";
import { Banner, BannerType, CreateBannerRequest } from "pages/banner-management/BannerType";
import { PaginationResponse } from "utils/PaginationType";

export const fetchBannerTypes = async (): Promise<PaginationResponse<BannerType>> => {
    const response = await axiosClient.get('/banner/type/all');
    return response.data;
};

export const fetchBannerByType = async (typeId: number): Promise<PaginationResponse<Banner>> => {
  const response = await axiosClient.get(`/banner/type/${typeId}/banner/all`);
  return response.data;
};

export const createBanner = async (banner: CreateBannerRequest): Promise<any> => {
  const response = await axiosClient.post('/banner/create', banner);
  return response.data;
}

export const updateBannerStatus = async (bannerId: number, isActive: boolean): Promise<any> => {
  const response = await axiosClient.patch(`/banner/${bannerId}/status`, { status: isActive });
  return response.data;
}

export const deleteBanner = async (bannerId: number): Promise<any> => {
  const response = await axiosClient.delete(`/banner/${bannerId}`);
  return response.data;
}